import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; // 🚩 Add this import
import App from './App'; // Or whatever your main file is named
import './styles.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter> {/* 🚩 Wrap your App here */}
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
